import { AuthProvider } from '@caterinx/api-client';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';

import '@fontsource-variable/inter';
import './index.css';

import { App } from './App.js';
import { authClient } from './lib/api.js';

const rootElement = document.getElementById('root');
if (!rootElement) {
  throw new Error('Kein #root-Element im Dokument gefunden.');
}

createRoot(rootElement).render(
  <StrictMode>
    <BrowserRouter>
      <AuthProvider client={authClient}>
        <App />
      </AuthProvider>
    </BrowserRouter>
  </StrictMode>
);
